import InsteadAuth from './src/instead-auth';

export default InsteadAuth;
